module.exports = __webpack_public_path__ + "static/media/sq-2.6273918c.png";